import React from "react";
import RegistryPage from "../components/RegistryPage";
import { StatusBadge } from "../components/Badges";
import { Btn } from "../components/Primitives";
import { toast } from "sonner";
import api from "../lib/api";
import { Sparkles } from "lucide-react";

const LAWFUL = ["consent","legitimate_use","legal_compliance","employment","medical_emergency","public_interest","state","other"];

export default function PurposeRegistry() {
  const genLanguage = async (item) => {
    try {
      const { data } = await api.post("/consents/generate-language", { purpose_id: item.id });
      alert(`Generated Consent Language:\n\n${data.content}`);
    } catch { toast.error("AI generation failed"); }
  };

  return (
    <RegistryPage
      title="Purpose & Lawful Basis Registry"
      description="Central registry of processing purposes with lawful basis and approvals."
      endpoint="/purposes"
      testIdPrefix="purposes"
      columns={[
        { key: "name", label: "Purpose" },
        { key: "lawful_basis", label: "Lawful basis", width: "140px" },
        { key: "consent_required", label: "Consent", width: "90px" },
        { key: "sharing_involved", label: "Sharing", width: "90px" },
        { key: "status", label: "Status", width: "110px", render: (i) => <StatusBadge status={i.status} /> },
      ]}
      fields={[
        { key: "name", label: "Purpose", required: true },
        { key: "description", label: "Description", type: "textarea", full: true, required: true },
        { key: "business_justification", label: "Business justification", type: "textarea", full: true },
        { key: "lawful_basis", label: "Lawful basis", type: "select", options: LAWFUL, required: true },
        { key: "consent_required", label: "Consent required", type: "checkbox" },
        { key: "withdrawal_allowed", label: "Withdrawal allowed", type: "checkbox" },
        { key: "retention_required_by_law", label: "Retention required by law", type: "checkbox" },
        { key: "sharing_involved", label: "Sharing involved", type: "checkbox" },
        { key: "cross_border_transfer", label: "Cross-border transfer", type: "checkbox" },
        { key: "business_process", label: "Business process" },
        { key: "legal_notes", label: "Legal notes", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", options: ["draft","active","retired"] },
      ]}
      defaultItem={{ name: "", description: "", lawful_basis: "consent", consent_required: true, withdrawal_allowed: true, status: "active" }}
      actions={(it) => (
        <button data-testid={`purpose-gen-consent-${it.id}`} onClick={() => genLanguage(it)} title="Generate consent language" className="p-1.5 text-slate-500 hover:text-blue-600">
          <Sparkles className="w-3.5 h-3.5" />
        </button>
      )}
    />
  );
}
